import { isReadOnlyPreviewEnabled } from '../../utils/readOnlyPreview';

const postDevTipsClicked = async (tips) => {
  if (isReadOnlyPreviewEnabled()) {
    return true;
  }

  const bearerToken = `Bearer ${localStorage.getItem('token')}`;
  try {
    let data = await fetch(
      process.env.REACT_APP_API_URL + `/api/developmentaltips`,
      {
        method: 'POST',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json',
          Authorization: bearerToken,
        },
        body: JSON.stringify(tips),
      }
    );
    if (data.ok) {
    } else {
      throw new Error();
    }
  } catch (err) {
    console.log(err);
  }
};

export default postDevTipsClicked;
